import React from 'react';
import styled from 'styled-components';
import { StoreCard } from './StoreCard';
import { googlePlay, apple, web } from '../../../../assets/svg/index';
import { device } from '../../../../constants';
import { PrivateDistribution } from './PrivateDistribution';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  storeLinks: string[];
  privateReason?: string | null | undefined;
}

export const ProjectStores: React.FC<DivProps> = ({ storeLinks, privateReason, ...props }) => {
  return (
    <StoreCards {...props}>
      {storeLinks.map((link, index) => {
        if (link.includes('play.google.com')) {
          return (
            <StoreCard
              key={index}
              img={googlePlay}
              subtitle="GET IT NOW"
              title="Google Play"
              link={link}
            />
          );
        } else if (link.includes('apps.apple.com')) {
          return (
            <StoreCard
              key={index}
              img={apple}
              subtitle="Download on the"
              title="App Store"
              link={link}
            />
          );
        } else {
          return (
            <StoreCard
              key={index}
              img={web}
              subtitle="START NOW"
              title="TRY IN WEB"
              link={link}
            />
          );
        }
      })}
      {storeLinks.length === 0 && <PrivateDistribution privateReason={privateReason} />}
    </StoreCards>
  );
};

const StoreCards = styled.div`
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  @media screen and ${device.bsm} {
    justify-content: center;
  }
  @media screen and ${device.sm} {
    gap: 6px;
  }
`;
